import { useEffect, useState } from 'react'

import { getLocalUserStatus } from '../lib/helpers/userStatusStorage'
import { UserStatus } from '../types/UserStatus.enum'

export const useAmpUserStatus = (): UserStatus => {
  const [status, setStatus] = useState<UserStatus>(() => getLocalUserStatus())

  useEffect(() => {
    const newStatus = getLocalUserStatus()
    setStatus(newStatus)
  }, [])

  return status
}
